module.exports = __webpack_public_path__ + "static/p14_cabrita-a2c0415b03ba545d0ba4f6bd4bd661ce.png";